module.exports = __webpack_public_path__ + "media/images/castbox-podcast-7e9ed5031480321c0cfd5685f9732aca.jpg";